var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLookingforme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_3787)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6915 18.1539C21.7725 18.1539 21.8546 18.1312 21.9268 18.0835C22.0964 17.9714 22.2677 17.8629 22.4412 17.7586C22.6388 17.6396 22.6995 17.387 22.5775 17.1944C22.456 17.0026 22.1977 16.9418 21.999 17.0613C21.8157 17.172 21.6346 17.2865 21.4551 17.4049C21.263 17.5318 21.2127 17.7866 21.3429 17.9738C21.4244 18.0909 21.5563 18.1539 21.6915 18.1539Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8436 19.1926C19.6795 19.0336 19.4124 19.0352 19.2493 19.1955C16.5093 21.8943 15 25.4742 15 29.2752C15 29.5014 15.1883 29.6849 15.4203 29.6849C15.6523 29.6849 15.8406 29.5014 15.8406 29.2752C15.8406 25.6913 17.2634 22.3163 19.8469 19.7722C20.01 19.6113 20.0089 19.3518 19.8436 19.1926Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1121 21.1835C34.9471 16.1497 26.5661 16.1497 21.4011 21.1835C16.2361 26.2172 16.2361 34.3911 21.4011 39.4249C26.5661 44.4527 34.941 44.4467 40.106 39.413C45.2771 34.3792 45.2832 26.2172 40.1121 21.1835ZM37.4077 36.8486C33.7289 40.4102 27.7842 40.4162 24.0993 36.8664C24.0871 36.8546 24.075 36.8368 24.0628 36.8308C20.3656 33.2217 20.3656 27.3747 24.0628 23.7775C27.7599 20.1803 33.7593 20.1803 37.4504 23.7775C41.1475 27.3747 41.1475 33.2217 37.4443 36.8249C37.4321 36.8368 37.4199 36.8427 37.4077 36.8486Z",
    fill: "url(#paint1_linear_4819_3787)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3802 45.8631L46.886 41.4765C46.0117 40.6243 44.7677 40.3512 43.6526 40.6571L41.8706 38.9145C41.5399 39.3296 41.187 39.723 40.8003 40.0999C40.4192 40.4768 40.0157 40.8265 39.5898 41.1433L41.3662 42.875C41.2822 43.1645 41.2429 43.4595 41.2429 43.7545C41.2429 44.5794 41.568 45.4042 42.2124 46.0324L46.7122 50.4136C48.0011 51.6755 50.0913 51.6755 51.3802 50.4136C52.0246 49.7854 52.3496 48.9605 52.3496 48.1411C52.3496 47.3162 52.0246 46.4913 51.3802 45.8631Z",
    fill: "url(#paint2_linear_4819_3787)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1159 45.3305C38.9517 45.1705 38.6857 45.1705 38.5216 45.3305C38.3574 45.4906 38.3574 45.7498 38.5216 45.9099L38.6556 46.0406C38.7377 46.1206 38.845 46.1606 38.9528 46.1606C39.0606 46.1606 39.1679 46.1206 39.2499 46.0406C39.4141 45.8805 39.4141 45.6213 39.2499 45.4612L39.1159 45.3305Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2184 46.4055C40.0542 46.2454 39.7883 46.2454 39.6241 46.4055C39.4599 46.5655 39.4599 46.8248 39.6241 46.9848L42.0396 49.339C42.1217 49.419 42.229 49.4591 42.3368 49.4591C42.4446 49.4591 42.5519 49.419 42.6339 49.339C42.7981 49.179 42.7981 48.9197 42.6339 48.7597L40.2184 46.4055Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0932 31.4836C32.4937 31.7949 31.8044 31.9752 31.0703 31.9752C30.3418 31.9752 29.6526 31.7949 29.0473 31.4836C27.5511 31.9806 26.3071 33.0186 25.5674 34.3569L25.573 34.3624C27.0132 35.7445 28.9745 36.5311 31.0591 36.5311C33.1381 36.5311 35.0938 35.75 36.5676 34.3351C35.8223 33.0076 34.5895 31.9752 33.0932 31.4836Z",
    fill: "#4F4F4F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3096 31.1371C33.2042 31.0056 34.6306 29.4018 34.4957 27.5549C34.3608 25.708 32.7156 24.3175 30.821 24.449C28.9265 24.5805 27.5 26.1843 27.6349 28.0312C27.7698 29.8781 29.415 31.2686 31.3096 31.1371Z",
    fill: "#4F4F4F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_3787",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4819_3787",
    x1: 30.7574,
    y1: 17.4082,
    x2: 30.7574,
    y2: 43.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4819_3787",
    x1: 45.9697,
    y1: 38.9145,
    x2: 45.9697,
    y2: 51.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookingforme);
export default __webpack_public_path__ + "static/media/LOOKINGFORME.69c7a43dcbab4c5208fe4022a9195924.svg";
export { ForwardRef as ReactComponent };